import StatusChip from './StatusChip.jsx';

const LIMIT_LABELS = {
  limite_kilos: 'KG',
  limite_bultos: 'Bultos',
  limite_valor_declarado: 'VD',
  limite_m3: 'M3',
  limite_rc: 'RC',
};

const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
};

export default function LimitChips({
  linea,
  className = '',
}) {
  const items = Object.entries(LIMIT_LABELS).map(([key, label]) => ({
    key,
    label,
    value: formatValue(linea?.[key]),
  }));

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`.trim()}>
      {items.map((item) => (
        <StatusChip
          key={item.key}
          tone={item.value === '-' ? 'muted' : 'brand'}
          label={`${item.label} ${item.value}`}
          title={`${item.label}: ${item.value}`}
          className="normal-case tracking-[0.04em]"
        />
      ))}
    </div>
  );
}
